import React from 'react';

interface BotanicalBackgroundProps {
  className?: string;
  section?: 'main' | 'rest' | 'registry';
}

const BotanicalBackground: React.FC<BotanicalBackgroundProps> = ({ 
  className = '',
  section = 'main'
}) => {
  // Seleccionamos imágenes específicas según la sección
  let images;
  
  if (section === 'main') {
    images = [24, 23, 22]; // Para el fondo principal
  } else if (section === 'registry') {
    images = [24]; // Solo una imagen para registry para evitar sobreposición
  } else {
    images = [24, 23]; // Para otras secciones como RSVP
  }

  // Si el className contiene "absolute", significa que se está usando en un contenedor de tamaño limitado
  const isContained = className.includes('absolute');

  // Calculamos altura según la sección
  const mainHeight = isContained ? '100%' : '800vh';
  const restHeight = isContained ? '100%' : '400vh';
  const registryHeight = isContained ? '100%' : '200vh'; // Altura menor para registry

  // Determinamos opacidad según sección
  const getOpacity = () => {
    if (section === 'registry') return 0.15; // Más sutil para registry
    return 0.25; // Normal para otras secciones
  };

  return (
    <div className={`${className}`} style={{ 
      position: 'absolute', 
      top: 0, 
      left: 0, 
      right: 0,
      zIndex: -10, 
      pointerEvents: 'none',
      // Altura ajustada según sección
      height: isContained 
        ? '100%' 
        : (section === 'main' 
            ? mainHeight 
            : (section === 'registry' ? registryHeight : restHeight)),
      // Degradado al final para evitar un corte abrupto
      maskImage: !isContained ? 'linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 97%, rgba(0,0,0,0) 100%)' : 'none',
      WebkitMaskImage: !isContained ? 'linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 97%, rgba(0,0,0,0) 100%)' : 'none'
    }}>
      {images.map((img, index) => (
        <div 
          key={index}
          style={{
            position: 'absolute',
            // Distribución vertical según sección
            top: isContained 
              ? `${index * 40}%` 
              : (section === 'registry' 
                  ? '0' // Para registry, la imagen va arriba
                  : `${index * 280}vh`),
            left: 0,
            width: '100%',
            height: isContained ? '150%' : '250vh',
            overflow: 'hidden'
          }}
        >
          <img 
            src={`/lovable-uploads/${img}.jpg`}
            alt=""
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center center',
              // Opacidad ajustada por sección
              opacity: getOpacity(),
              transform: 'scale(1.05)',
              filter: 'contrast(1.05) brightness(1.02)',
              // Desvanecimiento más pronunciado en los bordes
              maskImage: 'linear-gradient(to bottom, transparent 0%, black 20%, black 80%, transparent 100%)',
              WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, black 20%, black 80%, transparent 100%)'
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default BotanicalBackground;
